import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IconType} from '../../../../../services/icons.service';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../../icons-svgs/icons-svgs.component';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-expand-button',
    templateUrl: './expand-button.component.html',
    styleUrls: ['./expand-button.component.scss'],
    standalone: true,
    imports: [NgIf, IconComponent, NgClass, TranslateModule]
})
export class ExpandButtonComponent implements OnInit {

  // Nom de l'icone de **gauche**. Voir dans icons-svgs.ts pour la liste complète
  @Input() public icon1: IconType;
  // Nom de l'icone de **droite**. Voir dans icons-svgs.ts pour la liste complète
  @Input() public icon2: IconType;
  // Nom de l'icone qui remplace celle de **droite** après clic sur le bouton, peu importe le mode
  @Input() public icon3: IconType;
  // Nom de l'icone qui remplace celle de **gauche** après clic sur le bouton en mode toggle.
  @Input() public icon4: IconType;
  // Permet de gérer l'animation. Animation (mode par défaut) va rotate l'icone de gauche, toggle [...]
  @Input() public mode: 'animation' | 'toggle' = 'animation';
  // Ajout d'un texte visible au survole du bouton. Défault : ''. Facultatif
  @Input() public text1: string = '';
  // Ajout d'un texte visible au survole du bouton. Défault : ''. Facultatif. S'il existe, il remplacera text1 après le clic
  @Input() public text2: string = '';
  // Renvoie la valeur de isToggle (boolean, défault = false) au composant parent
  @Output() public toggleValue: EventEmitter<boolean> = new EventEmitter<boolean>();


  public isToggle: boolean = false;
  public toggledItem: string = 'left';
  public hideIcon2: boolean = false;


  constructor() {
  }

  ngOnInit(): void {
  }

  public toggle(): void {
    this.isToggle = !this.isToggle;
    this.toggleValue.emit(this.isToggle);
    if (this.icon3) {
      this.hideIcon2 = this.isToggle;
    }
  }

  public toggleLeftRight(value): void {
    this.toggledItem = value;
    this.toggleValue.emit(value);
  }

}
